<template lang="html">
  <div id="reschedulingSenderCompletion">
    <section class="section" v-if="!reschedulingInfo.isDenying">
      <h1 class="section-description">授業振替が確定しました</h1>
      <h1 class="section-description">{{ senderDisplayName }}へご入力内容を通知するメールが届きます</h1>
    </section>
    <section class="section" v-else>
      <h1 class="section-description">振替依頼を不承認し、他の振替候補日時を提案しました</h1>
      <h1 class="section-description">{{ senderDisplayName }}へご入力内容を通知するメールが届きます</h1>
    </section>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        reschedulingInfo: this.$store.state.reschedulingInfo
      }
    },
    computed: {
      senderDisplayName () {
        return this.reschedulingInfo.sender.fullname +
          (this.reschedulingInfo.sender.user_type === 'teacher' ? '先生' : '様')
      }
    }
  }
</script>
<style lang="css" scoped>
  .section {
    border-bottom: solid 2px black;
    text-align: center;
    margin: 10px 5% 10px 5%;
    padding-bottom: 20px;
  }
  .section-description {
    font-size: 18px;
    margin-bottom: 5px;
  }
</style>



// WEBPACK FOOTER //
// ReschedulingReceiverCompletion.vue?450b1e54